var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7EFF2CDB-67ED-4FCC-8108-8CB93A8532EB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(-24.000000, -72.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-trash",
    transform: "translate(24.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,8 L19,8 L19,18 C19,19.1045695 18.1045695,20 17,20 L7,20 C5.8954305,20 5,19.1045695 5,18 L5,8 Z",
    id: "Rectangle",
    fill: "#C5CDD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,8 C3.44771525,8 3,7.55228475 3,7 C3,6.44771525 3.44771525,6 4,6 L7,6 C7,4.34314575 8.34314575,3 10,3 L14,3 C15.6568542,3 17,4.34314575 17,6 L20,6 C20.5522847,6 21,6.44771525 21,7 C21,7.55228475 20.5522847,8 20,8 L4,8 Z M14,5 L10,5 C9.44771525,5 9,5.44771525 9,6 L15,6 C15,5.44771525 14.5522847,5 14,5 Z M10,11 C10.5522847,11 11,11.4477153 11,12 L11,16 C11,16.5522847 10.5522847,17 10,17 C9.44771525,17 9,16.5522847 9,16 L9,12 C9,11.4477153 9.44771525,11 10,11 Z M14,11 C14.5522847,11 15,11.4477153 15,12 L15,16 C15,16.5522847 14.5522847,17 14,17 C13.4477153,17 13,16.5522847 13,16 L13,12 C13,11.4477153 13.4477153,11 14,11 Z",
    id: "Shape",
    fill: "#7A858E"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/iconTrash.635bb938c1ce1126eb76e88cb16feb5f.svg";
export { ForwardRef as ReactComponent };